import * as Notifications from 'expo-notifications'
import i18n from '../translations/i18n'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

interface Args {
  pendingRecords: number
}

export const useSendNotifications = ({ pendingRecords }: Args) => {
  const { t } = useTranslation()

  const sendNotification = async () => {
    await Notifications.scheduleNotificationAsync({
      content: {
        title: t('Enviar'),
        body:
          i18n.language === 'es'
            ? `Tienes ${pendingRecords} registro${pendingRecords > 1 ? 's' : ''} pendiente${
                pendingRecords > 1 ? 's' : ''
              } por enviar`
            : `You have ${pendingRecords} pending record${pendingRecords > 1 ? 's' : ''} for send`,
      },
      trigger: null,
    })
  }

  useEffect(() => {
    if (pendingRecords > 0) {
      sendNotification()
    }
  }, [pendingRecords])
}
